export function downloadData(data: Uint8Array, name: string) {
  let blob = new Blob([data as any], { type: 'application/octet-stream' });
  let url = URL.createObjectURL(blob);
  let a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
}

export function stringToUint8Array(str: string): Uint8Array {
  return new Uint8Array([...str].map(char => char.charCodeAt(0)));
}

export function uint8ArrayToString(data: Uint8Array): string {
  return new TextDecoder().decode(data);
}

export function removePrinterChars(str: string) {
  let tmp = str.replace(/[\x03\x02]/g, '');
  tmp = tmp.replace(/\x1BE/g, '');
  tmp = tmp.replace(/\x1BF/g, '');
  tmp = tmp.replace(/\x1BW1/g, '');
  tmp = tmp.replace(/\x1BW0/g, '');
  tmp = tmp.replace(/\x1B@/g, '');
  // tmp = tmp.replace(/\xef/g, '');
  // tmp = tmp.replace(/\xbf/g, '');
  // tmp = tmp.replace(/\xbd/g, '');
  // this.testString(tmp);
  return tmp;

}

export function isElementVisibleInContainer(el: HTMLElement, container: HTMLElement | undefined) {
  if (!container) {
    return false;
  }
  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return (
    elRect.top >= containerRect.top &&
    elRect.bottom <= containerRect.bottom &&
    elRect.left >= containerRect.left &&
    elRect.right <= containerRect.right
  );
}


export function getFlexLayout(container: HTMLElement) {
  const children = Array.from(container.children);

  const rows: any = {};
  children.forEach(child => {
    let ch = child as HTMLElement;
    const top = ch.offsetTop;
    if (!rows[top]) rows[top] = [];
    rows[top].push(child);
  });

  const rowCount = Object.keys(rows).length;
  const columnCounts = Object.values(rows).map((row: any) => row.length);

  return {
    rowCount,
    columnCounts,   // number of columns in each row\
    maxCol: Math.max(...columnCounts),
    rows            // optional detailed mapping
  };
}